<ng-lottie
  [options]="config"
  (animationCreated)="handleAnimationCreated($event)"
  (configReady)="handleConfigReady()"
  (dataReady)="handleDataReady()"
  (domLoaded)="handleDomLoaded()"
  (enterFrame)="handleEnterFrame($event)"
  (segmentStart)="handleSegmentStart($event)"
  (complete)="handleComplete($event)"
  (loopComplete)="handleLoopComplete($event)"
  (destroy)="handleDestroy($event)"
  (error)="handleError($event)"
></ng-lottie>
